import React, { useEffect, useLayoutEffect, useState } from "react";
import AuthService from "../../Components/auth/AuthService";
import { useNavigate } from "react-router-dom";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import { Button, Dropdown, Form, List, message, Modal, Select, Table, Typography, Upload } from 'antd';
import { InboxOutlined, MoreOutlined, UploadOutlined } from "@ant-design/icons";
import Papa from "papaparse";
import * as XLSX from 'xlsx';
import moment from "moment";
import { domain, env, wms_uploads_bucket, wms_uploads_cdn } from "../../Components/config";
import qs from "query-string";
import { Pagination, styled } from "@mui/material";
import { importTypes, locationCategories, locationTypes, productCategories } from "../../Components/common/Constants";
import ImportModal from "../../Components/Modals/ImportModal";
import FileDetailsModal from "../../Components/Modals/FileDetailsModal";
import { useSelector } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";

const DataSheet = styled('div')`
    .ant-upload-list-item-name {
      font-size: 22px !important;
        color: #1890ff;       
  font-weight: bold;
    }
   .ant-upload-icon .anticon {
   font-size: 20px !important;
   }
   .ant-upload-wrapper .ant-upload-list .ant-upload-list-item .ant-upload-list-item-actions .ant-upload-list-item-action {
   font-size: 22px !important;
   }
   
 
  .ant-upload-wrapper .ant-upload-list .ant-upload-list-item {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 16px
  }
`;

const Auth = new AuthService();

export default function FileImport() {
  const { aisles, locations, products, obStatus } = useSelector((state) => state?.AppState?.userCreds);
  const navigate = useNavigate();
  const { Dragger } = Upload;
  const { Option } = Select;
  var layoutDispatch = useLoadingDispatch();
  const [file, setFile] = useState(null);
  const [importType, setImportType] = useState(null);
  const [isValidFile, setIsValidFile] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [allErrors, setAllErrors] = React.useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenDetails, setIsModalOpenDetails] = useState(false);
  const [newFile, setNewFile] = useState('');
  const [allCurrentFiles, setAllCurrentFiles] = useState([]);
  const [fileDetails, setFileDetails] = useState([]);

  const [dataToSend, setDataToSend] = useState('');

  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  

  const handleSelect = () => {
    setIsModalOpen(true);
  }

  const handleChange = (event, value) => {
    setPage(value);
    setPageChange(true)
  };

  const fileCol = [
    {
      title: 'File Name',
      dataIndex: 'file_name',
      key: 'file_name',
      render: (text) => {
        const encodedFileName = text?.replace(/\+/g, '%2B');
        return (
          <>
            <a
              href={`${wms_uploads_cdn}/${env}/warehouse-migrations/${importType === 1 ? "aisle" : importType == 2 ? 'location' : importType == 2 ? "product-locations" : 'opening-balance'}/${encodedFileName}`}
              target="_blank"
            >
              {extractOriginalFileName(text)}
            </a>
          </>
        );
      }
    },    
    {
      title: 'Uploaded At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => <>
      {dayjs(text).format('DD-MM-YYYY HH:mm')}
      </> 
    },
    {
      title: 'Action',
      key: 'action',
      dataIndex: '',
      align: 'center',
      render(record) {
        return (
          < >
            <Dropdown
              menu={{
                items: [
                  {
                    key: '1',
                    label: 'View Details',
                    onClick: () => getFileDetails(record),
                  },
                  {
                  key: '2',
                  label: 'Delete',
                  onClick: () => {
                    Modal.confirm({
                      title: 'Are you sure?',
                      content: 'This will permanently delete the record.',
                      okText: 'Yes, Delete',
                      okType: 'danger',
                      cancelText: 'Cancel',
                      onOk: () => handleDeleteRecord(record),
                    });
                  },
                },
                ],
              }}
            >
              <MoreOutlined />
            </Dropdown>
          </>
        );
      },
    },
  ]

  const aisleTemplate = [
    "title",
    "levels",
    "depth",
    "total_locations",    
];

  const locationTemplate = [
    "code",
    "title",
    "location_type",
    "pallet_capacity",
    "width",
    "height",
    "is_transit",
    'aisle',
    // 'category_type',
    'is_picking',
    'is_binning'
  ];

  const productLocationTemplate = [
    "aisle",
    "location",
    "product",
    // "location_type",
    // "is_transit",
    "is_picking",
    "is_binning",
  ];

  const openingBalanceTemplate = [
    // "aisle",
    // "location",
    "product",
    "quantity",
    // "location_type",
  ];

  const validateNumber = (value) => {
    return Number.isInteger(Number(value));
  };

  const validateNumberDouble = (value) => {
    return !isNaN(value) && value !== '';
  };

const props = {
  name: 'file',
  multiple: false,
  accept: '.csv, .xlsx',
  onRemove: (file) => {
    setFileList([]);
    setFile(null);
    setIsValidFile(false);
    setAllErrors([]);
  },

  beforeUpload: (file) => {
    const isCSV = file.type === 'text/csv';
    const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if (!isCSV && !isXLSX) {
      showMessage('error','You can only upload CSV or XLSX files!');
      setFile(null);
      setFileList([]);
      setIsValidFile(false);
      return false;
    }

    if (isCSV) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          setDataToSend(result.data)
          console.log('FileCheck', file);

          handleData(result.data, result.meta.fields, file);
        },
        error: (error) => {
          showMessage('error','Error parsing CSV file.');
          setFile(null);
          setFileList([]);
          setIsValidFile(false);
        }
      });
    } else if (isXLSX) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const result = XLSX.utils.sheet_to_json(sheet, { header: 1 });        

        // Convert the array of arrays to a more structured format
        const headers = result[0];
        const rows = result.slice(1).map(row => {
          const obj = {};
          headers.forEach((header, index) => {
            let value = row[index];
            obj[header] = value;
          });
          return obj;
        });
        console.log('rows, headers, file', rows, headers, file);
        
        setDataToSend(rows)
        console.log('FileCheck', file);
        
        handleData(rows, headers, file);

      };
      reader.readAsArrayBuffer(file);
    }

    return false;
  },

  onDrop(e) {
    console.log('Dropped files', e.dataTransfer.files);
    const file = e.dataTransfer.files[0];
    const isCSV = file.type === 'text/csv';
    const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if (!isCSV && !isXLSX) {
      showMessage('error','You can only upload CSV or XLSX files!');
      return;
    }
  },
};

// Separate function to handle data processing
const handleData = (data, headers, file) => {
  console.log('headers', headers, data);
  const filteredData = data;
  const template = importType === 1 ? aisleTemplate : importType === 2 ? locationTemplate : importType == 3 ? productLocationTemplate : openingBalanceTemplate;
  const isValidTemplate = template.every((field) => headers.includes(field)) && headers.every((header) => template.includes(header));
  // if (!headers.every((header) => template.includes(header))) {
    if (!isValidTemplate) {
    showMessage('error','File is not valid. Please use the correct template.');
    setFile(null);
    setFileList([]);
    setIsValidFile(false);
    setAllErrors([]);
  } else {
    
        const dataTypeErrors = [];
        if (importType === 2) {
      const aisleCountMap = {};

      filteredData.forEach((row) => {
        const aisleName = row.aisle;
        if (aisleName) {
          aisleCountMap[aisleName] = (aisleCountMap[aisleName] || 0) + 1;
        }
      });

      Object.entries(aisleCountMap).forEach(([aisleName, count]) => {
        const aisle = aisles.find((item) => item.title === aisleName);
        if (aisle && parseInt(aisle.total_locations) < count) {
          dataTypeErrors.push(
            `Total locations exceeded for aisle "${aisleName}". Allowed: ${aisle.total_locations}, Found: ${count}`
          );
        }
      });
    }

    const locationProductPairs = new Set();
    const locationCodes = new Set();

        filteredData.forEach((row, index) => {
          const rowNumber = index + 1;
          if (importType === 1) {
            const { title, levels, depth, total_locations, } = row;

              if (!title) dataTypeErrors.push(`Invalid title value in row ${rowNumber}.`);
  
            if (!levels || !validateNumber(levels)) {
              dataTypeErrors.push(`Invalid or missing levels in row ${rowNumber}.`);
            }
            if (!depth || !validateNumberDouble(depth)) {
              dataTypeErrors.push(`Invalid or missing depth in row ${rowNumber}.`);
            }
            if (!total_locations || !validateNumber(total_locations)) {
                dataTypeErrors.push(`Invalid or missing number of locations in row ${rowNumber}.`);
            }
            
            };
          if (importType === 2) {
           

            const { code, title,  location_type, pallet_capacity, width, height, is_transit, aisle, category_type, is_picking, is_binning } = row;

            if (!code) {
              dataTypeErrors.push(`Invalid code value in row ${rowNumber}.`);
            } else {
              if (locationCodes.has(code)) {
                dataTypeErrors.push(`Duplicate code "${code}" found in row ${rowNumber}.`);
              } else {
                locationCodes.add(code);
              }
            }
              // if (!code) dataTypeErrors.push(`Invalid code value in row ${rowNumber}.`);
              if (!title) dataTypeErrors.push(`Invalid title value in row ${rowNumber}.`);
              if (!is_transit) dataTypeErrors.push(`Invalid is transit value in row ${rowNumber}.`);
              if (!is_picking) dataTypeErrors.push(`Invalid is picking value in row ${rowNumber}.`);
              if (!is_binning) dataTypeErrors.push(`Invalid is binning value in row ${rowNumber}.`);
              if (!location_type) dataTypeErrors.push(`Invalid location type value in row ${rowNumber}.`);
              // if (!category_type) dataTypeErrors.push(`Invalid category value in row ${rowNumber}.`);
              if (!aisle) dataTypeErrors.push(`Invalid aisle value in row ${rowNumber}.`);

              const locationTypesExists = locationCategories.some(item => item?.title === location_type);
              const aisleExists = aisles.some(item => item.title === aisle);
              
            if (!pallet_capacity || !validateNumberDouble(pallet_capacity)) {
                dataTypeErrors.push(`Invalid or missing pallet capacity in row ${rowNumber}.`);
            }
            if (!width || !validateNumberDouble(width)) {
                dataTypeErrors.push(`Invalid or missing width in row ${rowNumber}.`);
            }
            if (!height || !validateNumberDouble(height)) {
                dataTypeErrors.push(`Invalid or missing height in row ${rowNumber}.`);
            }
            
              if (!aisleExists) {
                dataTypeErrors.push(`Aisle "${aisle}" does not exist in row ${rowNumber}.`);
              }
            if (!locationTypesExists) {
                dataTypeErrors.push(`Location type "${location_type}" does not exist in row ${rowNumber}.`);
              }


          }
          
          if (importType === 3) {
              const { aisle, location, product, location_type, is_transit, is_picking, is_binning } = row;
              console.log(aisle, location, product, location_type, 'row');
              
              if (!aisle) dataTypeErrors.push(`Invalid aisle value in row ${rowNumber}.`);
              if (!location) dataTypeErrors.push(`Invalid location value in row ${rowNumber}.`);
              if (!product) dataTypeErrors.push(`Invalid product value in row ${rowNumber}.`);
              // if (!location_type) dataTypeErrors.push(`Invalid location type value in row ${rowNumber}.`);
              // if (!is_transit) dataTypeErrors.push(`Invalid is transit value in row ${rowNumber}.`);
              if (!is_picking) dataTypeErrors.push(`Invalid is picking value in row ${rowNumber}.`);
              if (!is_binning) dataTypeErrors.push(`Invalid is binning value in row ${rowNumber}.`);

              const aisleExists = aisles.some(item => item.title === aisle);
              const locationExists = locations.some(item => item?.code === location);
              const productExists = products.some(item => item?.code === product);
              const locationTypesExists = locationCategories.some(item => item?.title === location_type);
              
              if (!aisleExists) {
                dataTypeErrors.push(`Aisle "${aisle}" does not exist in row ${rowNumber}.`);
              }
              if (!locationExists) {
                dataTypeErrors.push(`Location "${location}" does not exist in row ${rowNumber}.`);
              }
              if (!productExists) {
                dataTypeErrors.push(`Product "${product}" does not exist in row ${rowNumber}.`);
              }
              // if (!locationTypesExists) {
              //   dataTypeErrors.push(`Location type "${location_type}" does not exist in row ${rowNumber}.`);
              // }

              const key = `${location}|${product}`;
            if (locationProductPairs.has(key)) {
              dataTypeErrors.push(`Duplicate entry of location "${location}" with product "${product}" in row ${rowNumber}.`);
            } else {
              locationProductPairs.add(key);
            }
          };
        
        if (importType === 4) {
          const {  product, quantity } = row;
          // if (!aisle) dataTypeErrors.push(`Invalid aisle value in row ${rowNumber}.`);
          // if (!location) dataTypeErrors.push(`Invalid location value in row ${rowNumber}.`);
          if (!product) dataTypeErrors.push(`Invalid product value in row ${rowNumber}.`);
          // if (!location_type) dataTypeErrors.push(`Invalid location type value in row ${rowNumber}.`);
          if (!quantity) dataTypeErrors.push(`Invalid quantity value in row ${rowNumber}.`);
          if (!quantity || !validateNumberDouble(quantity)) {
            dataTypeErrors.push(`Invalid or missing quantity in row ${rowNumber}.`);
          }

          const validations = [
            // { exists: aisles.some(item => item.title === aisle), message: `Aisle "${aisle}" does not exist in row ${rowNumber}.` },
            // { exists: locations.some(item => item?.code === location), message: `Location "${location}" does not exist in row ${rowNumber}.` },
            { exists: products.some(item => item?.code === product), message: `Product "${product}" does not exist in row ${rowNumber}.` },
            // { exists: locationTypes.some(item => item?.title === location_type), message: `Location type "${location_type}" does not exist in row ${rowNumber}.` },
          ];
          
          validations.forEach(({ exists, message }) => {
            if (!exists) dataTypeErrors.push(message);
          });
          
        };
        });
  
        if (dataTypeErrors.length > 0) {
          console.log('dataTypeErrors', dataTypeErrors);
          setAllErrors([...dataTypeErrors]);
          setFile(null);
          setFileList([]);
          setIsValidFile(false);
        } else {
          setFile(file);
          setIsValidFile(true);
          setFileList([file]);
          setAllErrors([]);
        }
    
  }
};


  const handleDeleteRecord = async (record) => {

    const dataToSend = {
      id: record?.id,
      type: importType
    };
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch("/warehouse-migration/delete-migrations", {
        method: "DELETE",
        body: JSON.stringify(dataToSend),
      });
      if(response?.ack) {
        showMessage('success',response?.message)
        getAllCurrentFiles(importType)
      } else {
        showMessage('error',response?.message)
      }

    } catch (error) {
      console.log(error);
    } finally {
    hideLoading(layoutDispatch);
    }
  };

  const getFileDetails = async (record) => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/warehouse-migration/view-migrations?type=${importType}&migration_id=${record?.id}`);
      if (response?.ack) {
        console.log('response1111', response);
        
        if(importType === 1) {
          setFileDetails(response?.aisle_arr || [])
          setIsModalOpenDetails(true);

        }
        if(importType === 2) {
          setFileDetails(response?.location_arr || [])
          setIsModalOpenDetails(true);
        }
        if(importType === 3) {
          setFileDetails(response?.product_location_arr || [])
          setIsModalOpenDetails(true);
        }
        if(importType === 4) {
          setFileDetails(response?.opening_balance_arr || [])
          setIsModalOpenDetails(true);
        }
      }
    } catch (err) {
      console.log(err);
    } finally{
      hideLoading(layoutDispatch);
    }
  }


  const getAllCurrentFiles = async (type) => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/warehouse-migration/warehouse-migrations?type=${type}`);
      if (response?.ack) {
        // if(type === 1) {
          setAllCurrentFiles(response?.migrations || [])
          setTotalPages(Math.ceil(response.total_count / limit));
          setTotalCount(response.total_count);
        // }
        // if(type === 2) {
        //   setAllCurrentFiles(response?.location_arr || [])
        //   setTotalPages(Math.ceil(response.total_count / limit));
        //   setTotalCount(response.total_count);
        // }
        // if(type === 3) {
        //   setAllCurrentFiles(response?.product_location_arr || [])
        //   setTotalPages(Math.ceil(response.total_count / limit));
        //   setTotalCount(response.total_count);
        // }
        // if(type === 4) {
        //   setAllCurrentFiles(response?.opening_balance_arr || [])
        //   setTotalPages(Math.ceil(response.total_count / limit));
        //   setTotalCount(response.total_count);
        // }
      } else {
      showMessage('error',response?.message);

      }
    } catch (err) {
      console.log(err);
      showMessage('error', "Something went wrong");
    } finally{
      hideLoading(layoutDispatch);
    }
  }


function getNewFileName(oldFileName) {
  const extension = oldFileName?.slice(oldFileName?.lastIndexOf('.'));
  const baseName = oldFileName?.slice(0, oldFileName?.lastIndexOf('.'));
  const randomString = Math.random().toString(36).substring(2, 12);
  return `${baseName}-${randomString}${extension}`;
}

function extractOriginalFileName(modifiedFileName) {
  const extensionIndex = modifiedFileName?.lastIndexOf('.');
  const extension = modifiedFileName?.slice(extensionIndex);
  const randomStringPattern = /-\w{10}(?=\.\w+$)/;
  const baseName = modifiedFileName?.replace(randomStringPattern, '');
  return baseName;
}

const getUploadUrl = async (newFileName, type) => {
  const params = {
    bucket: wms_uploads_bucket,
    ContentType: file.type,
    Key: env + `/warehouse-migrations/${type}/` + newFileName,
  };
  const response = await fetch(
    `${domain}/generate-put-url?${qs.stringify(params)}`,
    {
      headers: {
        "Content-Type": params.ContentType,
      },
    }
  );
  return response.json();
};

const uploadFileToS3 = async (uploadUrl, contentType) => {
  const response = await fetch(uploadUrl.putURL, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": contentType,
    },
  });
  if (response.status !== 200) {
    throw new Error("File upload failed.");
  }
};


console.log(dataToSend, 'dataTosend');


// const handleSendFile = async () => {
//     const dataArray = dataToSend?.filter(item => item.title != '')
   
//     if(importType == 1) {
//     showLoading(layoutDispatch);
//     const newFileName = getNewFileName(file?.name);
//     setNewFile(newFileName)
//     const dataToSend = {
//       file_name: newFileName,
//       aisle_arr: dataArray.map(item => ({
//         title: item?.title,
//         levels: item?.levels,
//         depth: item?.depth,
//         total_locations: item?.total_locations,
//       }))
//     }
//     console.log('updated parsed Array', dataToSend);
//     try {
//       const res = await Auth.fetch("/warehouse-migration/aisle", {
//         method: "POST",
//         body: JSON.stringify(dataToSend),
//       })

//       if(res?.ack) {
//       const uploadPromises = []
//       uploadPromises.push(
//         getUploadUrl(newFileName, 'aisle')
//           .then(uploadUrl => uploadFileToS3(uploadUrl, file.type))
//           .catch(error => console.error("Error uploading file:", error))
//       );
//       await Promise.all(uploadPromises);
//       showMessage('success','Upload successful');
//       getAllCurrentFiles(importType)
//       } else {
//       showMessage('error',res?.message);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       hideLoading(layoutDispatch);
//     } 
//     } 
//     if(importType == 2) {
//     showLoading(layoutDispatch);
//     const newFileName = getNewFileName(file?.name);
//     setNewFile(newFileName)
//     const dataToSend = {
     
//       file_name: newFileName,
//       location_arr: dataArray.map(item => ({
//         code: item?.code,
//         title: item?.title,
//         location_type: item?.location_type, 
//         pallet_capacity: item?.pallet_capacity,
//         width: item?.width,
//         height: item?.height,
//         is_transit: item?.is_transit,
        
//       }))
//     }
//     console.log('updated parsed Array', dataToSend);
//     try {
//       const res = await Auth.fetch("/warehouse-migration/locations", {
//         method: "POST",
//         body: JSON.stringify(dataToSend),
//       })

//       if(res?.ack) {
//       const uploadPromises = []
//       uploadPromises.push(
//         getUploadUrl(newFileName, 'location')
//           .then(uploadUrl => uploadFileToS3(uploadUrl, file.type))
//           .catch(error => console.error("Error uploading file:", error))
//       );
//       await Promise.all(uploadPromises);
//       showMessage('success','Upload successful');
//       getAllCurrentFiles(importType)
//       } else {
//       showMessage('error',res?.message);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       hideLoading(layoutDispatch);
//     } 
//     } 

//     if(importType == 3) {
//       showLoading(layoutDispatch);
//       const newFileName = getNewFileName(file?.name);
//       setNewFile(newFileName)
//       const dataToSend = {
       
//         file_name: newFileName,
//         product_location_arr: dataArray.map(item => ({
//           asile: item?.asile,
//           location: item?.location,
//           location_type: item?.location_type, 
//           product: item?.product,
          
//         }))
//       }
//       console.log('updated parsed Array', dataToSend);
//       try {
//         const res = await Auth.fetch("/warehouse-migration/product-locations", {
//           method: "POST",
//           body: JSON.stringify(dataToSend),
//         })
  
//         if(res?.ack) {
//         const uploadPromises = []
//         uploadPromises.push(
//           getUploadUrl(newFileName, 'product-locations')
//             .then(uploadUrl => uploadFileToS3(uploadUrl, file.type))
//             .catch(error => console.error("Error uploading file:", error))
//         );
//         await Promise.all(uploadPromises);
//         showMessage('success','Upload successful');
//         getAllCurrentFiles(importType)
//         } else {
//         showMessage('error',res?.message);
//         }
//       } catch (error) {
//         console.log(error);
//       } finally {
//         hideLoading(layoutDispatch);
//       } 
//       } 
  
// }

const handleSendFile = async () => {
  const filteredData = dataToSend?.filter(item => item.title !== '');

  showLoading(layoutDispatch);
  const newFileName = getNewFileName(file.name);
  setNewFile(newFileName);

  let endpoint = "";
  let bodyData = {};
  let s3Type = "";

  if (importType === 1) {
    endpoint = "/warehouse-migration/aisles";
    s3Type = "aisle";
    bodyData = {
      file_name: newFileName,
      aisle_arr: filteredData.map(item => ({
        title: item?.title,
        levels: item?.levels,
        depth: item?.depth,
        total_locations: item?.total_locations,
      })),
    };
  } else if (importType === 2) {
    endpoint = "/warehouse-migration/locations";
    s3Type = "location";
    bodyData = {
      file_name: newFileName,
      location_arr: filteredData.map(item => ({
        code: item?.code,
        title: item?.title,
        type: item?.location_type,
        category_type: item?.category_type,
        pallet_capacity: item?.pallet_capacity,
        width: item?.width,
        height: item?.height,
        is_transit: item?.is_transit,
        is_picking: item?.is_picking,
        is_binning: item?.is_binning,
        aisle_id: aisles?.find((aisle)=> aisle.title == item?.aisle)?.id || null,
        aisle: aisles?.find((aisle)=> aisle.title == item?.aisle)?.title || null,
      })),
    };
  } else if (importType === 3) {
    endpoint = "/warehouse-migration/product-locations";
    s3Type = "product-locations";
    bodyData = {
      file_name: newFileName,
      product_location_arr: filteredData.map(item => ({
        aisle: item?.aisle, 
        location: item?.location,
        // type: item?.location_type,
        product: item?.product,
        // is_transit: item?.is_transit,
        is_picking: item?.is_picking,
        is_binning: item?.is_binning,
      })),
    };
  } else if (importType === 4) {
    endpoint = "/warehouse-migration/opening-balances";
    s3Type = "opening-balance";
    bodyData = {
      file_name: newFileName,
      opening_balance_arr: filteredData.map(item => ({
        // aisle: item?.aisle, 
        // location: item?.location,
        product: item?.product,
        quantity: item?.quantity,
        // type: item?.location_type,
      })),
    };
  } else {
    hideLoading(layoutDispatch);
    return showMessage('error',"Invalid import type");
  }

  console.log('Sending parsed data:', bodyData);

  try {
    const res = await Auth.fetch(endpoint, {
      method: "POST",
      body: JSON.stringify(bodyData),
    });

    if (res?.ack) {
      try {
        const uploadUrl = await getUploadUrl(newFileName, s3Type);
        await uploadFileToS3(uploadUrl, file.type);
        showMessage('success','File Uploaded successful');
        getAllCurrentFiles(importType);
        setFile(null);
        setFileList([]);
        setIsValidFile(false);
        setAllErrors([]);
      } catch (uploadErr) {
        console.error("Error uploading file:", uploadErr);
        showMessage('error',"File upload failed");
      }
    } else {
      showMessage('error',res?.message || "Upload failed");
      if(importType == 2 || importType == 1) {
        setAllErrors(res?.errors || []);
      }
    }
  } catch (error) {
    console.error("Request error:", error);
    showMessage('error',"Unexpected error occurred");
  } finally {
    hideLoading(layoutDispatch);
  }
};


  useEffect(() => {
    if (importType) {
      setFile(null);
      setFileList([]);
      setIsValidFile(false);
      setAllErrors([]);
    }
  }, [importType]);

  useEffect(() => {
    if(!importType) return;
    const timeOutId = setTimeout(() => getAllCurrentFiles(importType), 100);
    return () => clearTimeout(timeOutId);
  }, [page]);



  return (
    <DataSheet>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>Migrations</h3>
        <Button type="link" onClick={()=> handleSelect()}>
          Browse Templates
        </Button>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Form size="medium" layout="vertical" name="migrations">
          <Form.Item label="Migration Type">
            <Select 
              value={importType} 
              placeholder="Select File Type" 
              onChange={(value) => {
                setImportType(value)
                getAllCurrentFiles(value)
              }}>
              {importTypes
                .filter(item => !(obStatus && item.title === "Opening Balance"))
                .map(item => (
                  <Option key={item.id} value={item.id}>
                    {item.title}
                  </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </div>

      {
        importType && (
            <>
            <Dragger {...props} style={{ marginBottom: '5px', marginTop: '5px'}} fileList={isValidFile ? [file] : []}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
        <p className="ant-upload-hint">
          Strictly prohibited from uploading company data or other banned files.
        </p>
       
      </Dragger>
      {
  allErrors.length > 0 && (
    <List
      size="small"
      header={<span style={{ fontWeight: 'bold'}}>Errors</span>}
      footer={null}
      bordered
      dataSource={allErrors}
      renderItem={(item) => <List.Item style={{ color: 'red'}}>{item}</List.Item>}
    />
  )
}
      {isValidFile && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: '10px' }}>
        <Button 
        icon={<UploadOutlined/>}
        onClick={() => {
          console.log('File is valid and can be uploaded:', file, fileList);
          handleSendFile()
        }}>
          Upload File
        </Button>
        </div>
      )}
        </>
        )
      }
        {
          importType && (
            <>
            <h3 style={{ marginTop: '20px' }}>File Records</h3>
            <div >
          <Table
          columns={fileCol}
          style={{ overflowX: "auto", marginTop: '10px' }}
          pagination={false}
          bordered
          dataSource={allCurrentFiles}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          // footer={() => `List of Files Record - Total count: ${allCurrentFiles?.length || 0} `}
          footer={() => {
            const startRecord = (page - 1) * limit + 1;
            const endRecord = Math.min(page * limit, allCurrentFiles.length ? totalCount : 0); 
            return `Showing ${startRecord}-${endRecord} of ${allCurrentFiles.length ? totalCount : "0"} Records`;
          }}
        />
      </div>
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
            </>
            
          )
        }
        
      
        <ImportModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}  />
        <FileDetailsModal isModalOpen={isModalOpenDetails} setIsModalOpen={setIsModalOpenDetails} fileDetails={fileDetails} importType={importType} extractOriginalFileName={extractOriginalFileName} />
    </DataSheet>
  );
}